import './common-styles';
import '@/styles/dmq-my.scss';

import './common-code';
import { getModule } from 'vuex-module-decorators';
import store from '@/store';
import SalesRegionsModule from '@/store/modules/sales-regions-module';
import DmqMyRegions from '@/components/DmqMyRegions.vue';

document.querySelectorAll('.dmq-my-section-head').forEach((el: Element) => {
  const hel = el as HTMLLinkElement;
  hel.onclick = (ev) => {
    const section = (hel.closest('.dmq-my-section') as HTMLElement | null);
    const isExpanded = section ? section.classList.contains('dmq-my-section--expanded') : false;
    document.querySelectorAll('.dmq-my-section').forEach((sel: Element) => {
      (sel as HTMLElement).classList.remove('dmq-my-section--expanded');
    });
    if (section && !isExpanded) {
      section.classList.add('dmq-my-section--expanded');
    }
  };
});

const mySaleRegionsEl = document.getElementById('dmq-my-sale-regions') as HTMLElement;
if (mySaleRegionsEl) {
  new DmqMyRegions({
    store,
  }).$mount(mySaleRegionsEl);
}
